<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="classesairlines.icon" class="mr-1"></i>
            <span>{{ classesairlines.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Airline" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="airline" :debounce="classesairlines.debounce"
                      placeholder="Airline"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!airline" @click="airline = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Code" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="classesairlines.debounce" placeholder="Code"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="classesairlines.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Class Type" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="classtype" :debounce="classesairlines.debounce"
                      placeholder="Code Type"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!classtype" @click="classtype = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Fare Type" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="faretype" :debounce="classesairlines.debounce"
                      placeholder="Fare Type"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!faretype" @click="faretype = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="classesairlines" :icon="classesairlines.icon"
            :busy="classesairlines.busy" :toolbarlibrary="classesairlines.toolbarlibrary" :tools="classesairlines.tools"
            :badges="classesairlines.badges" :fields="classesairlines.fields" :items="classesairlines.items"
            :limit="classesairlines.limit" :downloaded="classesairlines.downloaded" :showpages="true"
            :offset="classesairlines.offset" :page="classesairlines.page" @load="classesairlines_load"
            @click="classesairlines_click" @changed="classesairlines_click('save', $event)"
            @select="classesairlines_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="classesairlines.selected" :config="cconfig"
          @discard="classesairlines_click('discard')" @go="classesairlines_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import FlightsClassesExceptionsEdit from "./Components/Setup_FlightsClassesExceptionsEdit";

export default {
  name: "ClassesExceptions",
  components: { FlightsClassesExceptionsEdit },
  watch: {
    async airline() {
      console.log("airline", this.airline);
      await this.classesairlines_load(0);
    },
    async code() {
      console.log("code", this.code);
      await this.classesairlines_load(0);
    },
    async description() {
      console.log("description", this.description);
      await this.classesairlines_load(0);
    },
    async classtype() {
      console.log("classtype", this.classtype);
      await this.classesairlines_load(0);
    },
    async faretype() {
      console.log("faretype", this.faretype);
      await this.classesairlines_load(0);
    },
  },
  data() {
    return {
      airline: null,
      code: null,
      description: null,
      classtype: null,
      faretype: null,

      classesairlines: {
        title: "Classes Airlines",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "airline",
            label: "Airline",
            sortable: true,
          },
          {
            key: "code",
            label: "Code",
            sortable: true,
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "classtype",
            label: "Class Type",
            sortable: true,
          },
          {
            key: "faretype",
            label: "Fare Type",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.classesairlines_load();
  },

  methods: {
    accessdenied() {
      this.classesairlines.denied = [];
      if (!this.user.permissions.includes("setup_cabinclassairlines.admin")) {
        this.classesairlines.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_cabinclassairlines.admin")) {
        this.classesairlines.denied.push("add");
        this.classesairlines.denied.push("save");
      }

    },


    async classesairlines_load(offset, limit, page) {
      let state = this.classesairlines;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        airline: this.airline,
        code: this.code,
        description: this.description,
        classtype: this.classtype,
        faretype: this.faretype,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_classesairlines(
                $limit: Int
                $offset: Int
                $id: String
                $airline: String
              $description: String
              $code: String
              $classtype: String
              $faretype: String
              $dateformat: String      
              ) {
                setup_classesairlines(
                  limit: $limit
                  offset: $offset
                  id: $id
                  airline: $airline
                description: $description
                code: $code
                classtype: $classtype
                faretype: $faretype
                dateformat: $dateformat
                ) {
                  id
                  airline
                description
                code       
                classtype
                faretype
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_classesairlines
        } else {
          state.items = response.data.setup_classesairlines;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async classesairlines_click(a, ss) {

      let state = this.classesairlines;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.classesairlines_load(0, 0);
          break;


        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.classesairlines_load();
          break;
        case "go":
          this.component = null;
          await this.classesairlines_load();
          break;
        case "add":
        case "edit":
          this.component = "FlightsClassesExceptionsEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async classesairlines_select(ss, tools) {

      let state = this.classesairlines;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_classesairlines_save(
                $rows: [setup_classesairlines_input]             
              ) {
                setup_classesairlines_save(rows: $rows) {
                  id
                  airline
                  description
                  code         
                  classtype
                  faretype
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_classesairlines_delete(
                $rows: [setup_classesairlines_input]
              ) {
                setup_classesairlines_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.classesairlines_load(0);
    },
  },
};
</script>

<style scoped></style>